var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34666 13.6671C1.97332 13.6671 1.65555 13.5359 1.39332 13.2737C1.1311 13.0115 0.99999 12.694 0.99999 12.3212V2.00039H0.166656V1.16706H3.49999V0.525391H8.49999V1.16706H11.8333V2.00039H11V12.3212C11 12.7046 10.8717 13.0248 10.615 13.2821C10.3583 13.5393 10.0378 13.6676 9.65332 13.6671H2.34666ZM10.1667 2.00039H1.83332V12.3212C1.83332 12.4707 1.88138 12.5934 1.97749 12.6896C2.0736 12.7857 2.19666 12.8337 2.34666 12.8337H9.65416C9.78193 12.8337 9.89944 12.7804 10.0067 12.6737C10.1139 12.5671 10.1672 12.4493 10.1667 12.3204V2.00039ZM4.17332 11.1671H5.00666V3.66706H4.17332V11.1671ZM6.99332 11.1671H7.82666V3.66706H6.99332V11.1671Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.becf626363be414f60cda2bb3fc90362.svg";
export { ForwardRef as ReactComponent };